import React, { useContext } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { Layout } from 'components'
import { UserContext } from 'contexts'
import { ConfigUtils } from 'utils/config'
import { getDefaultRoute } from 'utils/roles'

import { Users } from './Users'
import { Admins } from './Admins'
import { DrawerItems } from './DrawerItems'
import { Stores } from './Stores'
import { Memberships } from './Memberships'
import { Download } from './Downloads'
// import { Notifications } from './Notifications'
import { Tags } from './Tags'
// import { ManualRewards } from './ManualRewards'
import { Dashboard } from './Dashboard'
import { UserPolls } from './UserPoll'
import { AutomaticNotifications } from './AutomaticNotifications'
import { Prizes } from './Prizes'
import { Styles } from './Styles'
import { Coupons } from './Coupons'
import { Campaigns } from './Campaigns'
import NewDashboard from './NewDashboard'
import { Configuraciones } from './Configuraciones'
import { Loyalty } from './Loyalty'
import { Reviews } from './Reviews'

const Main: React.FC = () => {
  const { admin } = useContext(UserContext)
  if (!admin) return <Navigate to="/login" replace />

  const defaultRoute = getDefaultRoute(admin)
  const routes = (
    <Routes>
      <Route path="/" element={<Navigate to={defaultRoute} replace />} />
      <Route path="/loyalty" element={<Loyalty />} />
      <Route path="/configuraciones" element={<Configuraciones />} />
      {/* Mantener rutas antiguas para compatibilidad hacia atrás */}
      <Route path="/users" element={<Users />} />
      <Route path="/admins" element={<Admins />} />
      <Route path="/drawer-items" element={<DrawerItems />} />
      <Route path="/stores" element={<Stores />} />
      <Route path="/coupons" element={<Coupons />} />
      <Route path="/campaigns" element={<Campaigns />} />
      <Route path="/vouchers" element={<Navigate to="/campaigns?tab=vouchers" replace />} />
      <Route path="/memberships" element={<Memberships />} />
      <Route path="/rewards-automatizados" element={<Prizes />} />
      {/* <Route path="/rewards-manuales" element={<ManualRewards />} /> */}
      <Route path="/downloads" element={<Download />} />
      {/* <Route path="/notifications" element={<Notifications />} /> */}
      <Route path="/notificaciones/automaticas" element={<AutomaticNotifications />} />
      <Route path="/tags" element={<Tags />} />
      <Route path="/user-test" element={<UserPolls />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/styles" element={<Styles />} />
      <Route path="/new-dashboard" element={<NewDashboard />} />
      {ConfigUtils.reviews.enabled && <Route path="/reviews" element={<Reviews />} />}
      <Route path="*" element={<h1>404 no encontrado</h1>} />
    </Routes>
  )

  return <Layout>{routes}</Layout>
}

export { Main }
